import React from 'react';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

const LoadingButton = ({ 
  children, 
  loading = false, 
  loadingText, 
  disabled,
  className,
  size = 'default',
  ...props 
}) => {
  const spinnerSize = {
    sm: 'sm',
    default: 'sm', 
    lg: 'default'
  }[size] || 'sm';

  return (
    <Button
      disabled={loading || disabled}
      className={cn(
        loading && 'cursor-not-allowed',
        className
      )}
      size={size}
      {...props}
    >
      {loading && (
        <Spinner 
          size={spinnerSize} 
          className="mr-2 text-current" 
        />
      )}
      {loading ? (loadingText || 'Chargement...') : children}
    </Button>
  );
};

export { LoadingButton };